import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      backgroundColor: '#fff',
      borderRadius: 16,
      border: `1px solid rgba(228, 232, 236, 0.5)`,
      padding: 20,
      [theme.fn.largerThan('md')]: {
        padding: `24px 24px 24px 72px`,
        borderRadius: 32,
      },
    },
    container: {
      display: 'flex',
      [theme.fn.smallerThan('md')]: { flexDirection: 'column', gap: rem(24) },
      [theme.fn.largerThan('md')]: {
        gap: rem(48),
        justifyContent: 'space-between',
        alignItems: 'stretch',
      },
    },
    icon: {
      width: rem(40),
    },
    iconWrapper: {
      flexShrink: 0,
    },
    heading: {
      fontSize: 26,
      lineHeight: rem(36),
      fontWeight: 500,
      [theme.fn.largerThan('md')]: {
        fontSize: 48,
        lineHeight: rem(58),
      },
    },
    info: {
      display: 'flex',
      gap: rem(16),

      flexDirection: 'column',
      [theme.fn.largerThan('md')]: {
        flexDirection: 'column',
        gap: rem(24),
        alignItems: 'flex-start',
      },
    },
    infoTop: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(16),
      [theme.fn.largerThan('md')]: {
        gap: rem(24),
      },
    },
    infoCol: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(16),
      justifyContent: 'space-between',
      maxWidth: 711,
      [theme.fn.largerThan('md')]: {
        gap: rem(24),
        paddingTop: 48,
      },
    },
    imgCol: {
      [theme.fn.largerThan('md')]: {
        width: '100%',
        maxWidth: rem(532),
      },
    },
    boxFrame: {
      position: 'relative',
      borderRadius: rem(12),
      [theme.fn.largerThan('md')]: {
        borderRadius: rem(24),
        '&:before': {
          content: '""',
          height: 0,
          display: 'block',
          paddingBottom: '100%',
        },
      },
    },
    boxFrameInner: {
      borderRadius: 'inherit',
      [theme.fn.largerThan('md')]: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    thumbnail: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'cover',
    },
    imgHref: {
      display: 'block',
    },
    img: { borderRadius: 'inherit' },
    ctaBtn: {
      minWidth: rem(180),
    },
    disclaimerRoot: {},
    disclaimerTargetBtn: {},
    disclaimerDropdown: {},
    disclaimerIcon: {},
    btn: {
      position: 'relative',
      zIndex: 1,
      padding: 0,
      border: 0,
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },
      fontWeight: 400,
    },
    btnIcon: {
      marginLeft: 8,
    },
  }
})
